"use client";

import { Text } from "@leabankab/component-library";

type Props = {
	text: string;
};

export const SigningErrorFooter = ({ text }: Props) => (
	<Text color="text.subtle" align="center" className="mt-2">
		{text}
	</Text>
);
